<template>
  <v-container v-if="$store.state.menu.Clients" fill-height fluid grid-list-xl>
    <Loader :loading="loading" />
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="green" title="Список покупателей" text="DTE">
          <v-btn class="mr-2" color="primary" @click="getSerials(false)" text>Обновить</v-btn>
          <!-- <v-btn @click="openExport" color="danger"  text>Экспорт excel</v-btn> -->
          <div class="mt-2">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск..."
            class="sticky search"
            :loading="loadingSearch"
            single-line
            hide-details
            clearable="true"
          ></v-text-field>
                </div>
          <v-data-table :headers="headers" :items="PagesList" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td :class="`text-xs-left`">{{ item.phone_number }}</td>
              <td :class="`text-xs-left`">{{ item.first_name }}</td>
              <td :class="`text-xs-left`">{{ item.last_name }}</td>
              <td class="text-xs-left">{{ item.created_at | dateTime }}</td>
              <td class="text-xs-left">
                <button
                  @click="getActivationsList(item)"
                  :value="item.id"
                  class="link"
                >Смотреть детали</button>
              </td>
            </template>
          </v-data-table>
          <div class="horizontal-scroll">
            <v-pagination
              total-visible="20"
              v-if="last_page>1"
              v-model="page"
              class="my-4"
              :length="last_page"
            ></v-pagination>
          </div>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-if="currentClient"
      persistent
      fullscreen
      transition="dialog-bottom-transition"
      v-model="currentClient"
    >
      <v-card>
        <v-btn class="close default v-btn--simple" @click="closeClient">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <br />
        <br />
        <v-card-text>
          <Loader :loading="loadingActivations" />
          <h2>
            <span v-if="currentClient.first_name">{{currentClient.first_name}}</span>
            <span v-if="currentClient.last_name">{{currentClient.last_name}}</span>
          </h2>
          <h4>
            <span v-if="currentClient.phone_number">{{currentClient.phone_number}}</span>
          </h4>

          <v-data-table :headers="headersClient" :items="activationsList" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-if="item.options" slot="items" slot-scope="{ item }">
              <td class="text-xs-left">{{ item.options.serial_number }}</td>
              <td class="text-xs-left">{{ item.options.code_client }}</td>

              <td class="text-xs-left">
                <span v-if="item.options.product_info">{{item.options.product_info.vendor_code}}</span>
                <span v-else>Товар удален</span>
              </td>

              <td class="text-xs-left">
                <span v-if="item.options.product_info">{{item.options.product_info.name}}</span>
                <span v-else>Товар удален</span>
              </td>

              <td class="text-xs-left">
                <span
                  v-if="item.options.activations"
                  @click="SET_USER(item.options.activations.dealer.id)"
                >
                  <small>{{ item.options.activations.dealer.title }}</small>
                  <br />
                  <span class="user-link">
                    
                    {{ item.options.activations.dealer.phone_number }}
                  </span>
                </span>
                <span v-else class="text-error">Дилер не активировал</span>
              </td>

              <td class="text-xs-left">
                <span v-if="item.raffle">{{ item.raffle.content_admin.title }}</span>
              </td>
              <td class="text-xs-left">
                <span v-if="(item.outlet) && item.outlet.id!==9">{{ item.outlet.title }}</span>
                <span v-else>{{item.address}}</span>
              </td>
              <td class="text-xs-right">{{ item.created_at | dateTime }}</td>
            </template>
          </v-data-table>
          <div class="horizontal-scroll">
            <v-pagination
              v-if="lastPageActivations>1"
              v-model="pageActivations"
              total-visible="20"
              class="my-4"
              :length="lastPageActivations"
            ></v-pagination>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      width="900"
      persistent
      transition="dialog-bottom-transition"
      v-model="export_data.length && !loading"
    >
      <v-card>
        <v-card-text>
          <div class="body-2">Выгрузите экспорт</div>
          <br />
          <br />
          <download-excel
            v-if="export_data.length && loading===false"
            :data="export_data"
            :fields="json_fields_all_products"
            :name="'export_' + exportFileName"
          >
            <v-btn color="warning" text style="width:100%">Скачать</v-btn>
          </download-excel>

          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn color="primary" text style="width:100%" @click="export_data=[]">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Loader from "../components/helper/Loader";

import { mapMutations } from "vuex";
import Page from "../components/core/Pages/Page";

export default {
  data: () => ({
    //export
    loadingActivations: true,
    currentClient: null,
    pageActivations: 1,
    exportFileName: "",
    activationsList: [],
    lastPageActivations: 0,
    countActivations: 0,

    json_fields_all_products: {
      "Серийный номер наклейки": "code",
      "Серийный номер товара": "serial_number",
      Артикул: "vendor_code",
      "Наименование товара": "product_name",
      Награда: "reward",
      "Цена ACC": "conditional_price",
      "Дилер ": "dealer_name",
      "Дилер номер телефона": "dealer_phone",
      Клиент: "client_name",
      "Клиент номер телефона": "client_phone"
    },
    export_data: [],

    //export
    Page_title: "",
    PageAddModal: false,
    page: 1,
    searcher: null,
    loadingSearch: true,
    loading: true,
    last_page: 0,
    search: "",
    headers: [
      {
        sortable: false,
        text: "Номер телефона",
        value: "Номер телефона"
      },
      {
        sortable: false,
        text: "Имя",
        value: "Имя"
      },
      {
        sortable: false,
        text: "Фамилия",
        value: "Фамилия"
      },

      {
        sortable: false,
        text: "Дата регистрации"
      },
      {
        sortable: false,
        text: "Детали"
      }
    ],

    headersClient: [
      {
        sortable: false,
        text: "Серийный номер",
        value: "serial_number"
      },
      {
        sortable: false,
        text: "Секретный ключ",
        value: "code"
      },
      {
        sortable: false,
        text: "Артикул",
        value: "product.vendor_code"
      },
      {
        sortable: false,
        text: "Наименование товара",
        value: "product.title"
      },
      {
        sortable: false,
        text: "Дилер",
        value: "reward"
      },

      {
        sortable: false,
        text: "Розыгрышь (название)",
        value: "dealer.title"
      },
      {
        sortable: false,
        text: "Место покупки",
        value: "dealer.phone_number"
      },
      {
        sortable: false,
        text: "Дата активации",
        value: "created_at",
        align: "right"
      }
    ],
    PagesList: [],
    pageID: null
  }),
  components: { Page, Loader },
  methods: {
    ...mapMutations(["SET_USER", "SET_BADGE_ORDERS"]),
    setOrders(val) {
      if (val) {
        this.getSerials();
      }
    },
    openExport() {
      this.exportFileName = "serials.xls";
      this.loading = true;

      setTimeout(() => {
        axios
          .get("admin/export/serials", {
            params: {
              search: this.search
            }
          })
          .then(async response => {
            this.export_data = await response.data;
          })
          .catch(error => {})
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
            }, 3000);
          });
      }, 100);
    },
    getSerials(noLoading) {
      if (!noLoading) this.loading = true;

      axios
        .get("admin/clients/list", {
          params: {
            page: this.page,
            search: this.search
          }
        })
        .then(response => {
          this.PagesList = response.data.data;
          this.last_page = response.data.last_page;
        })
        .catch(error => {})
        .finally(() => {
          this.loadingSearch = false;
          this.loading = false;
        });
    },
    openPage(pageID) {
      this.pageID = pageID;
    },
    closePage(update) {
      if (update) {
        this.getSerials(false);
      }
      this.pageID = null;
    },
    addPage() {
      if (this.Page_title) {
        axios
          .post("admin/pages/set", {
            title: this.Page_title
          })
          .then(response => {
            if (response.data) {
              this.getSerials(true);
              this.openPage(response.data.id);
              this.Page_title = "";
            }
            this.$toast.success({
              title: "Успешно добавно",
              message: "Добавлена новая страница."
            });
          })
          .catch(error => {
            let data = error.response.data;
            if (data.errors) {
              let k = 0;
              Object.keys(data.errors).forEach(item => {
                let err = data.errors[item];
                k++;
                for (let i = 0; i < err.length; i++) {
                  setTimeout(() => {
                    this.$toast.error({
                      title: "Ошибка",
                      message: err[i]
                    });
                  }, 100 * k);
                }
              });
            }
          })
          .finally(() => {
            this.loading = false;
            this.PageAddModal = false;
          });
      } else {
        this.$toast.error({
          title: "Заголовок",
          message: "Введите заголовок"
        });
      }
    },
    closeClient() {
      this.currentClient = null;
      this.activationsList = [];
      this.pageActivations = 1;
    },
    getActivationsList(item) {
      this.loadingActivations = true;
      if (!this.currentClient) {
        this.currentClient = item;
      }
      axios
        .get("admin/activations-client", {
          params: {
            per_page: 10,
            dealer_id: this.currentClient.id,
            page: this.pageActivations
          }
        })
        .then(response => {
          this.activationsList = response.data.data;
          this.lastPageActivations = response.data.last_page;
          this.countActivations = response.data.total;
        })
        .catch(error => {})
        .finally(() => {
          this.loadingActivations = false;
        });
    }
  },

  watch: {
    search() {
      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getSerials(true);
      }, 1500);
    },
    page() {
      setTimeout(() => {
        this.getSerials();
      }, 300);
    },
    pageActivations() {
      setTimeout(() => {
        this.getActivationsList();
      }, 300);
    }
  },
  mounted() {
    this.getSerials();
  }
};
</script>
